import './Footer.css';

export function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>About Jester Chess</h3>
          <p>
            Jester Chess is a free online chess variant that brings excitement and unpredictability to the classic game. 
            Play against friends or random opponents in real-time matches.
          </p>
        </div>
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul className="footer-links">
            <li><a href="/privacy.html">Privacy Policy</a></li>
            <li><a href="/terms.html">Terms of Service</a></li>
            <li><a href="/about.html">About</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Contact</h3>
          <p>
            Questions or feedback? We'd love to hear from you. 
            Jester Chess is committed to providing a fun and fair gaming experience.
          </p>
          <p>
            <a href="mailto:support@jesterchess.co">support@jesterchess.co</a>
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Jester Chess. All rights reserved.</p>
      </div>
    </footer>
  );
}

